module.exports = __webpack_public_path__ + "static/media/import_icon.99c5fcba.svg";